export const getConfirmPaymentReadyDialogOpen = (state) => {
  return state.VNDialogs.get('confirmPaymentDialog')
}

export const getConfirmationDialog = (state) => {
  return state.VNDialogs.get('confirmationDialog')
}

export const getCFDPairedDialogOpen = (state) => {
  return state.VNDialogs.get('CFDPairedDialog')
}

export const getVnTipEntryDialog = (state) => {
  return state.VNDialogs.get('tipEntryModal')
}

export const getMobileScanPaymentDialog = (state) => {
  return state.VNDialogs.get('mobileScanPaymentDialog')
}

export const getDebugDialogOpen = (state) => {
  return state.VNDialogs.get('debugDialogOpen')
}

export const getCustomerPaymentDialogOpen = (state) => {
  return state.VNDialogs.get('customerPaymentDialog')
}

export const getCustomerViewingReceipt = (state) => {
  return state.VNDialogs.get('customerViewingReceipt')
}

export const getCustomerPayingWithCard = (state) => {
  return state.VNDialogs.get('customerPayingWithCard')
}

export const getTransactionCompleteDialog = (state) => {
  return state.VNDialogs.get('transactionCompleteDialog')
}

export const getTransactionErrorDialog = (state) => {
  return state.VNDialogs.get('transactionErrorDialog')
}

export const getCustomerEnteringTipDialogOpen = (state) => {
  return state.VNDialogs.get('customerEnteringTipDialog')
}

export const getCardAuthStepOne = (state) => {
  return state.VNDialogs.get('cardAuthStepOne')
}

export const getCardAuthStepTwo = (state) => {
  return state.VNDialogs.get('cardAuthStepTwo')
}

export const getUnavailableOfflineDialog = (state) => {
  return state.VNDialogs.get('offlineDialog')
}

export const getStopSyncWarningDialog = (state) => {
  return state.VNDialogs.get('syncWarningDialog')
}

export const getConnectionRequiredDialogOpen = (state) => {
  return state.VNDialogs.get('connectionRequiredDialog')
}

export const getKitchenPrintErrorDialogOpen = (state) => {
  return state.VNDialogs.get('kitchenPrintErrorDialog')
}

export const getBackbarFinalizeDialogOpen = (state) => {
  return state.VNDialogs.get('backbarFinalizeDialog')
}

export const getBalanceLookupDialog = (state) => {
  return state.VNDialogs.get('balanceLookupDialog')
}

export const getPrinterNotConfiguredDialog = (state) => {
  return state.VNDialogs.get('printerNotConfiguredDialog').get('open')
}

export const getBlockRichCheckoutOrderDialog = (state) => {
  return state.VNDialogs.get('openPriceRichCheckoutDialog')
}

export const getPriceAdjustExitConfirmation = (state) => {
  return state.VNDialogs.get('priceAdjustExitConfirmation')
}

export const getPriceAdjustmentDialog = (state) => {
  return state.VNDialogs.get('priceAdjustmentDialog').get('open')
}

export const getCurrentPriceAdjustment = (state) => {
  return state.VNDialogs.get('priceAdjustmentDialog').get('current')
}

export const getLatestPriceAdjustment = (state) => {
  return state.VNDialogs.get('priceAdjustmentDialog').get('latest', null)
}

export const getCannotReopenTabDialog = (state) => {
  return state.VNDialogs.get('cannotReopenTabDialog').get('open')
}

export const getReopenTabDialog = (state) => {
  return state.VNDialogs.get('reopenTabDialog')
}

export const getCannotReopenUnsyncedTabDialog = (state) => {
  return state.VNDialogs.get('cannotReopenUnsyncedTabDialog').get('open')
}

export const getCFDMessageReceiptErrorDialog = (state) => {
  return state.VNDialogs.get('CFDMessageReceiptErrorDialog').get('open')
}

export const getCFDNotPairedDialog = (state) => {
  return state.VNDialogs.get('CFDNotPairedDialog').get('open')
}

export const getCFDBlockingDialog = (state) => {
  return state.VNDialogs.get('CFDBlockingDialog').get('message')
}

export const getTaxDisplayDialog = (state) => {
  return state.VNDialogs.get('taxDisplayDialog')
}

export const getEnteringInputDialog = (state) => {
  return state.VNDialogs.get('enteringInputDialog')
}

export const getStartATabModal = (state) => {
  return state.VNDialogs.get('startATabModal')
}

export const getTabPaymentMethodModal = (state) => {
  return state.VNDialogs.get('tabPaymentMethodModal')
}

export const getConfirmDefaultTipModal = (state) => {
  return state.VNDialogs.get('confirmDefaultTipModal')
}

export const getTransferTabModal = (state) => {
  return state.VNDialogs.get('transferTabModal')
}

export const getCashPaymentAlreadyAppliedModal = (state) => {
  return state.VNDialogs.get('cashPaymentAlreadyAppliedModal')
}

export const getInfoDialog = (state) => {
  return state.VNDialogs.get('infoDialog')
}

export const getMobileQrReceiptDialog = (state) => {
  return state.VNDialogs.get('mobileQrReceipt')
}
